import { PolicyWorksheetViewDTO, WorksheetItemViewDTO } from "@swivl-mono/api-helper";

import { PolicySearchEntry, SearchResultCategory } from "./GlobalSearch.Types";

// Adapts the same getWorksheets response PolicyWorksheetsView already fetches.
// Server already filters staff-only items, so nothing extra needed here.

function itemSnippet(item: WorksheetItemViewDTO): string | undefined {
  const optionText = item.options?.map((o) => o.label).join(" ");
  return [item.hint, item.body, optionText].filter(Boolean).join(" ") || undefined;
}

function itemMatchText(item: WorksheetItemViewDTO): string {
  return [item.label, itemSnippet(item)].filter(Boolean).join(" ").toLowerCase();
}

function worksheetMatchText(worksheet: PolicyWorksheetViewDTO): string {
  return [worksheet.title, worksheet.description, worksheet.groupLabel, ...(worksheet.probeQuestions ?? [])].join(" ").toLowerCase();
}

export function buildPolicySearchEntries(worksheets: PolicyWorksheetViewDTO[]): PolicySearchEntry[] {
  const entries: PolicySearchEntry[] = [];

  for (const worksheet of worksheets) {
    // No breadcrumb — POLICIES header already covers it.
    entries.push({
      id: `policy:${worksheet.policyKey}`,
      category: SearchResultCategory.POLICY,
      title: worksheet.title,
      snippet: worksheet.description,
      policyKey: worksheet.policyKey,
      matchText: worksheetMatchText(worksheet)
    });

    for (const item of worksheet.items) {
      // static_text / dynamic_reference render no label — not a real field.
      if (item.kind === "static_text" || item.kind === "dynamic_reference") continue;
      if (!item.label) continue;

      entries.push({
        id: `policy:${worksheet.policyKey}:${item.itemKey}`,
        category: SearchResultCategory.POLICY,
        title: item.label,
        snippet: itemSnippet(item),
        breadcrumb: worksheet.title,
        policyKey: worksheet.policyKey,
        matchText: itemMatchText(item)
      });
    }
  }

  return entries;
}
